export const DefaultOrigins = [
  { id: "za-eastern-cape", name: "Eastern Cape" },
  { id: "za-free-state", name: "Free State" },
  { id: "za-gauteng", name: "Gauteng" },
  { id: "za-kwazulu-natal", name: "KwaZulu-Natal" },
  { id: "za-limpopo", name: "Limpopo" },
  { id: "za-mpumalanga", name: "Mpumalanga" },
  { id: "za-north-west", name: "North West" },
  { id: "za-northern-cape", name: "Northern Cape" },
  { id: "za-western-cape", name: "Western Cape" },
];

